import { Icon, tailwindPreset } from '@southfields-digital/mxmz-react-ui';

import { CanvasOption } from '../CanvasOutputPicker/types';

export const hasResolutionMismatch = (graphic: Graphic, canvas: Canvas | CanvasOption): boolean => {
  if (!graphic.config.resolution || !canvas.width || !canvas.height) return false;
  return !(
    graphic.config.resolution.width === canvas.width &&
    graphic.config.resolution.height === canvas.height
  );
};

type ResolutionMismatchWarningProps = {
  graphic: Graphic;
  canvas: Canvas | CanvasOption;
  className?: string;
};

export default function ResolutionMismatchWarning({
  graphic,
  canvas,
  className,
}: ResolutionMismatchWarningProps) {
  if (!hasResolutionMismatch(graphic, canvas)) return null;

  const title = `Graphic (${graphic.config.resolution?.width}×${graphic.config.resolution?.height}) doesn't match canvas (${canvas.width}×${canvas.height})`;

  return (
    <div className={className} title={title}>
      <Icon
        icon="warning"
        color={tailwindPreset.theme.extend.colors.warning}
        weight="duotone"
        className="hover:opacity-80"
      />
    </div>
  );
}
